// Section for import npm components -----------------------------------------------------------------------------------
import React, { useState, useEffect } from 'react';

// Material UI ( mui ) components
import { Box } from '@mui/material';

// Section for import custom components --------------------------------------------------------------------------------
import SubTitle from '@components/common/SubTitle';
import MansionList from '@components/common/MansionList';
import { getMansionEstates } from '@features/MansionPopular/api/mansionestates';

// Section for import custom types -------------------------------------------------------------------------------------
import MansionPopularPropsData from '@/types/components/MansionPopular/MansionPopularPropsData';
import { MansionListItemPropsData } from '@/types/components/common/MansionList/MansionListPropsData';

// Section for render component ----------------------------------------------------------------------------------------
export default function MansionPopular(props: MansionPopularPropsData): React.JSX.Element {
  const [mansionData, setMansionData] = useState<MansionListItemPropsData[]>([]);
  const { limit, title, prefecture } = props;
  useEffect(() => {
    getMansionEstates(limit, prefecture).then((response) => {
      setMansionData(response.results);
    });
  }, []);

  return (
    <Box className="md:mx-24 max-md:mx-4 mb-10 max-md:mb-5">
      <Box>
        <SubTitle title={title} />
      </Box>
      <MansionList results={mansionData} />
    </Box>
  );
}
